/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
export const useUpgradeSubscriptionStore = defineStore("upgradeSubscriptionStore", {
  state: () => ({
    saving: false,
    alerts: {},
    subscriptions: {},
    subscriptionProducts: [],
    accounts: []
  }),
  actions: {
    async getSubscriptions() {
      try {
        const response = await axios({
          url: `/subscription`
        });
        this.$patch({
          subscriptions: response.data
        });
      } catch (error) {
        this.alerts.error(error.message || error.response.data.message);
      }
    },
    async updateSubscriptions(params) {
      try {
        const response = await axios({
          url: `/subscription`,
          method: "PUT",
          data: params
        });
        this.$patch({
          subscriptions: response.data
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.message || error.response.data.message);
      }
    },
    async listSubscriptionProducts() {
      try {
        const response = await axios({
          url: `/subscription/products`
        });
        this.$patch({
          subscriptionProducts: response.data
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.message || error.response.data.message);
      }
    },
    async listAccounts() {
      try {
        const response = await axios({
          url: `/accounts`
        });
        this.$patch({
          accounts: response.data
        });
        return response.data;
      } catch (error) {
        this.alerts.error(error.message || error.response.data.message);
      }
    },
    async bank() {
      try {
        const data = await axios({
          url: `/subscription/checkout-session`,
          method: "POST",
          params: {
            types: "us_bank_account",
            redirect: '/#/reports/upgrade'
          }
        });
        if (data && data.data) {
          window.location.href = data.data;
        }
        return data;
      } catch (error) {
        this.alerts.error(error.message || error.response && error.response.data.message);
      }
    },
    async card() {
      try {
        const data = await axios({
          url: `/subscription/checkout-session`,
          method: "POST",
          params: {
            types: "card",
            redirect: '/#/reports/upgrade'
          }
        });
        if (data && data.data) {
          window.location.href = data.data;
        }
        return data;
      } catch (error) {
        this.alerts.error(error.message || error.response && error.response.data.message);
      }
    },
    getProPlansFromPlanInterval(interval) {
      const proProduct = this.subscriptionProducts.products.find(product => product.leanlawProductId === "pro");
      if (proProduct) {
        return {
          plans: proProduct.plans.filter(plan => plan.interval === interval)
        };
      } else {
        return {
          plans: []
        };
      }
    },
    listEmailsWithSetupAccess() {
      const accounts = this.accounts.accounts;
      return accounts.filter(account => account.access && account.access.setup).map(account => ({
        name: account.name,
        email: account.email
      }));
    }
  }
});